import Link from 'next/link'
import { useRouter } from 'next/router'
import { Breadcrumb } from 'types/breadcrumb'

import { addLocalePrefix } from 'lib/addLocalePrefix'

import styles from './BreadcrumbListComponent.module.scss'

interface Props {
  menus: Breadcrumb[]
}

const BreadcrumbComponent: React.VFC<Props> = ({ menus }: Props) => {
  const { locale } = useRouter()

  return (
    <ul className={styles.breadcrumb}>
      <li className={styles.breadcrumbItem}>
        <Link href={addLocalePrefix('/', locale)}>ecbo cloak</Link>
      </li>
      {menus.map((menu: Breadcrumb, index) => (
        <li className={styles.breadcrumbItem} key={index}>
          {menus.length === index + 1 || !menu.path || menu?.path === '' ? (
            <span>{menu.label}</span>
          ) : (
            <a href={addLocalePrefix(menu.path, locale)}>{menu.label}</a>
          )}
        </li>
      ))}
    </ul>
  )
}

export default BreadcrumbComponent
